var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import deleteServiceSchema from '../../requests/service/deleteServiceSchema';
import Signals from '../../signals/Signals';
/**
 *
 */
var DeleteServiceSchemaCommand = /** @class */ (function (_super) {
    __extends(DeleteServiceSchemaCommand, _super);
    function DeleteServiceSchemaCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param organisation OrganisationModel
     * @param schema SchemaModel
     * @param schemaCollection SchemaCollection
     * @param intl
     * @return {*}
     */
    DeleteServiceSchemaCommand.prototype.execute = function (organisation, schema, schemaCollection, intl) {
        this.intl = intl;
        this.schema = schema;
        this.schemaCollection = schemaCollection;
        var promise = deleteServiceSchema(schema.id, organisation.id);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    DeleteServiceSchemaCommand.prototype.then = function (response) {
        // Remove from collection
        this.schemaCollection.remove(this.schema);
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.service.schema.deleted' }, Object(this.schema)), 'dark', true);
    };
    return DeleteServiceSchemaCommand;
}(Command));
export default DeleteServiceSchemaCommand;
